import { PageHeader } from "../../Components/PageHeader";
import React from "react";
import styles from "./PageTemplate.module.scss";
export const PageTemplate: React.FC<{}> = ({ children }) => {
    return (
        <div className={`${styles.page ?? ""} container-fluid`}>
            <PageHeader />

            {children}
        </div>
    );
};
